var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agentgrid-illustration"},[_c('img',{staticClass:"agentgrid-panel",attrs:{"src":require("@/assets/illustrations/auth/agentgrid-panel.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }